export default __webpack_public_path__ + "static/media/NoirPro-Medium.a4383e1d.woff";